<template>
  <div></div>
</template>

<script>
export default {
  name: 'elConfigList'
}
</script>

<style></style>
